import { Button, ButtonProps, Row } from "@commonlibs";
import clsx from "clsx";
import ChevronLeftIcon from "ui/common/icons/ChevronLeftIcon";
import { spacing } from "ui/config/theme/spacing/spacing";
import useTranslate from "ui/locale/hooks/useTranslate";
import useGoBack from "ui/router/hooks/useGoBack";

export type GoBackButtonProps = Omit<ButtonProps, "children" | "onClick"> & {
    onBack?: () => void;
    /**
     * Custom go back function
     */
    goBack?: () => void;
};

const GoBackButton = ({ className, onBack, variant = "outlined", size = "md", goBack: goBackProp, ...rest }: GoBackButtonProps) => {
    const translate = useTranslate();
    const goBack = useGoBack();

    function handleClick() {
        (goBackProp || goBack)();
        onBack?.();
    }
    return (
        <Button className={clsx("go-back-btn", className)} {...rest} onClick={handleClick} variant={variant} size={size}>
            <Row gap={spacing["2"]} alignItems="center">
                <ChevronLeftIcon />
                <span>{translate("back")}</span>
            </Row>
        </Button>
    );
};

export default GoBackButton;
